






























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class PaymentItem extends Vue {
	name = "payment-item";
	@Prop() private isPaypal!: boolean;

	get cardnumber() {
		return this.$store.state.account.cardnumber;
	}
	get cardAddress() {
		return this.$store.state.account.cardAddress;
	}
	get amount() {
		return this.$store.state.account.amount;
	}
	get lastPayment() {
		return this.$store.state.account.lastPayment;
	}
	get paypalEmail() {
		return this.$store.state.account.paypalEmail;
	}
	get paypalUser() {
		return this.$store.state.account.paypalUser;
	}
}
